<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-clipboard-text-multiple
      </v-icon> Webhooks
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <br>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="webhooksList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>
              <font
                v-if="item.customer_name !== null"
                class="cust-name"
              >
                {{ item.customer_name }}
              </font>
              <font v-else>
                N/A
              </font>
            </td>
            <td>{{ item.type }}</td>
            <td>
              <font class="evnt-id">
                {{ item.stripe_id }}
              </font>
            </td>
            <td>
              {{ item.created_at | convertStringToLocalDatetime }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  export default {
    name: 'WebhooksList',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Customer Name', value: 'customer_name' },
          { text: 'Event Type', align: 'start', value: 'type' },
          { text: 'Event Id', value: 'stripe_id' },
          { text: 'Triggered At', value: 'created_at' },
        ],
      };
    },
    computed: {
      webhooksList () {
        const list = this.$store.getters['payments/getWebhooksList'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
      },
    },
    async mounted () {
      await this.getWebhooksList();
    },
    methods: {
      async getWebhooksList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchWebhooksList');
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
.font-my-style {
  font-weight: bold;
}
.font-my-style {
  font-weight: bold;
}
.cust-name {
  text-transform: capitalize;
}
</style>
